import {
  Button,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';

import { Icon, Loading, Mask, Pill } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { COMPANY_USER_REGISTER_STATUS_DATA } from '@services/CompanySetupService/dtos/ListCompanyDTO';

import { PartnerCompanyTypeChip } from '@components';
import { useAuth } from '@hooks';
import { UserType } from '@contexts';

import { StyledSummaryCardNewContainer } from './styles';
import { useSelectCompany } from '../../../../hooks';
import type { CompanySetupListMobileProps } from './types';

export function CompanySetupListMobile({
  companySetupListData,
  hasNextPage,
  fetchNextPage,
}: Readonly<CompanySetupListMobileProps>) {
  const { handleSelectCompany } = useSelectCompany();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));

  const { user } = useAuth();
  const isBackoffice = user?.companyType === UserType.Backoffice;

  const companyData =
    companySetupListData?.pages?.map(company => company?.companies).flat() ??
    [];

  return (
    <InfiniteScroll
      dataLength={companyData?.length}
      hasMore={!!hasNextPage}
      next={fetchNextPage}
      loader={<Loading animationProps={{ height: 40, width: 40 }} />}
      height={'calc(100vh - 210px)'}
    >
      <Grid container spacing={1} flexDirection="row" flexWrap="wrap" pr={2}>
        {companyData?.map(company => (
          <Grid item xs={isTablet ? 6 : 12} key={company?.id}>
            <StyledSummaryCardNewContainer gap={1}>
              <Stack flexDirection="row" justifyContent="space-between">
                <Stack gap={1} flexDirection="row">
                  {company?.totalMainPartnerCompanies !== 0 && (
                    <PartnerCompanyTypeChip
                      size="small"
                      isMainPartnerCompany
                      text={company?.totalMainPartnerCompanies}
                      title="Contrato mãe"
                    />
                  )}

                  {company?.totalPartnerCompanies !== 0 && (
                    <PartnerCompanyTypeChip
                      size="small"
                      isMainPartnerCompany={false}
                      text={company?.totalPartnerCompanies}
                      title="Contrato filho"
                    />
                  )}
                </Stack>
                {company?.status && isBackoffice && (
                  <Pill
                    fitContent
                    text={
                      COMPANY_USER_REGISTER_STATUS_DATA[company?.status].text
                    }
                    color={
                      COMPANY_USER_REGISTER_STATUS_DATA[company.status].color
                    }
                  />
                )}
              </Stack>
              <Typography
                variant="text"
                fontWeight={700}
                title={company?.name}
                color={NEW_COLORS.GRAYSCALE[700]}
              >
                {company?.name}
              </Typography>
              <Typography fontWeight={400}>
                {Mask.cnpj(company?.document)}
              </Typography>
              <Button
                onClick={() =>
                  handleSelectCompany({
                    ...company,
                  })
                }
                variant="outlined"
                fullWidth
                color="secondary"
                endIcon={
                  <Icon
                    name="actions-b2b-chevron-right"
                    color={NEW_COLORS.PRIMARY[700]}
                    size={24}
                  />
                }
              >
                Selecionar e avançar
              </Button>
            </StyledSummaryCardNewContainer>
          </Grid>
        ))}
      </Grid>
    </InfiniteScroll>
  );
}
